"use client";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";

import { useStore, observer } from "../../../../service/mobx";
import { RenderMarkdownCode } from "../../../../component/Markdown/Code";
import Tabs from "../../../../component/Tabs";

function Code({ model }) {
  const [tabs] = useState([
    { label: "python" },
    { label: "javascript" },
    { label: "julia" },
    { label: "http" }
  ]);
  const [index, setIndex] = useState(() => {
    try {
      return sessionStorage.getItem("preferred-lang") || "0";
    } catch {
      return "0";
    }
  });
  const [code, setCode] = useState("");
  const { device, user } = useStore();
  const key = user.profile?.key;

  useEffect(() => {
    const language = tabs[index].label;
    const userKey = key ?? "YOUR KEY";
    const { modelId } = model;
    let code;
    const input = tasks[model.task];
    const takesJSON = Array.isArray(input) || input?.constructor === Object;
    let runMap = input
      ? takesJSON
        ? JSON.stringify(input, undefined, 2)
        : `"${input}"`
      : "";
    const juliaReduceToDict = obj =>
      Object.entries(obj)
        .reduce(
          (string, [key, value]) =>
            (string += `"${key}" => ${
              Array.isArray(value) ? JSON.stringify(value) : `"${value}"`
            }, `),
          " Dict("
        )
        .slice(0, -2) + ") ";

    switch (language) {
      case "python": {
        code = `
          from bytez import Bytez
          client = Bytez("${userKey}");

          # 1) - select
          model = client.model("${modelId}")

          # 2) - load
          model.create()

          # 3) - run
          output = model.run(${runMap})

          print(output)
      `;
        break;
      }
      case "javascript": {
        code = `
          import Bytez from "bytez.js";
          const client = new Bytez("${userKey}");

          // 1) - select
          const model = client.model("${modelId}")

          // 2) - load
          await model.create()

          // 3) - run
          const { output } = await model.run(${runMap})

          console.log(output)
        `;
        break;
      }
      case "julia": {
        code = `
          using Bytez
          client = Bytez.init("${userKey}");

          # 1) - select
          model = client.model("${modelId}")

          # 2) - load
          model.load()

          # 3) - run
          output = model.run(${
            input
              ? takesJSON
                ? Array.isArray(input)
                  ? input.map(juliaReduceToDict)
                  : juliaReduceToDict(input)
                : `"${input}"`
              : ""
          })

          println(output)
        `;
        break;
      }
      case "http": {
        code = `# REST/CRUD endpoint (see docs for api reference)\n\ncurl --location --request POST 'https://api.bytez.com/models/v2/${modelId}' \\
          --header 'Authorization: Key ${userKey}' \\
          --header 'Content-Type: application/json' \\
          --data {{data_to_send_to_model}}
        `;
        break;
      }
    }

    setCode(`\`\`\`${language}\n${code.trim().replace(/ {10}/g, "")}\n\`\`\``);
    sessionStorage.setItem("preferred-lang", index);
  }, [tabs, model, key, index]);

  return (
    <Box
      p={{ compact: 0, expanded: 2 }}
      pt={{ compact: 1, expanded: 2 }}
      borderRadius="var(--shape-md-round)"
    >
      <Tabs
        noOutline
        tabs={tabs}
        initial={index}
        onChange={setIndex}
        variant={device.isPhone ? "scrollable" : undefined}
      />
      <Box
        maxHeight={500}
        sx={{ overflowX: "hidden", overflowY: "overlay !important" }}
      >
        <RenderMarkdownCode md={code} />
      </Box>
    </Box>
  );
}

export default observer(Code);

const tasks = {
  "sentence-similarity": "This text will converted to a vector",
  "fill-mask":
    "Hello <mask>... be sure to read docs for the right fill mask :)",
  "text-to-speech": "This is being read aloud",
  "text-to-audio": "Describe the audio you want",
  "text-to-image": "A cat in a hat",
  translation: "This text will be translated",
  summarization: "This text will be summarized",
  "text-to-video": "",
  "feature-extraction": "This text will converted to a vector",
  "text-classification": "",
  "token-classification": "",
  "text2text-generation": "",
  "text-generation": "",
  chat: [{ role: "user", content: "hello" }],
  "mask-generation": "",
  "image-to-text": "",
  "object-detection": "",
  "depth-estimation": "",
  "image-segmentation": "",
  "image-classification": "",
  "image-feature-extraction": "",
  "video-classification": "",
  "question-answering": "",
  "document-question-answering": "",
  "visual-question-answering": "",
  "zero-shot-object-detection": "",
  "zero-shot-image-classification": "",
  "zero-shot-classification": "",
  "automatic-speech-recognition": "",
  "audio-classification": "",
  "unconditional-image-generation": ""
};
